import { Controller } from "stimulus";

export default class extends Controller {
  get link() {
    return this.element.querySelector(".js-link");
  }

  handleClick(e) {
    e.preventDefault();
    window.location.href = this.link.href;
  }
}
